import i18n from '@/i18n';
import camelcase from 'camelcase';

export default class GlobalEvent {
  public id: string;
  public eventType: string;
  public eventTypeName: string;
  public eventText: string;
  public data;

  constructor(options) {
    this.id = options.id;
    this.eventType = options.eventType;
    this.data = options.data;
    this.eventTypeName = i18n.t(`globalEvents.${camelcase(this.eventType)}.title`).toString();
    this.eventText = this.calculateText();
  }

  private calculateText = () => i18n.t(
    `globalEvents.${camelcase(this.eventType)}.description`, { data: this.data },
  ).toString();
}
